var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 185,
    viewBox: "0 0 141 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter0_f_3163_1427)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 129.671H13.998L67.3513 25.9282L126.633 129.671Z",
    fill: "url(#paint0_linear_3163_1427)",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter1_f_3163_1427)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 130H13.998L67.3513 56.8862L126.633 130Z",
    fill: "url(#paint1_linear_3163_1427)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter2_f_3163_1427)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 130H13.998L67.3513 56.8862L126.633 130Z",
    fill: "url(#paint2_linear_3163_1427)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter3_f_3163_1427)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 130H13.998L67.3513 37.126L126.633 130Z",
    fill: "url(#paint3_linear_3163_1427)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#filter4_f_3163_1427)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 130H13.998L67.3513 37.126L126.633 130Z",
    fill: "url(#paint4_linear_3163_1427)",
    fillOpacity: 0.04
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    filter: "url(#filter5_f_3163_1427)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 130H13.998L67.3513 20L126.633 130Z",
    fill: "url(#paint5_linear_3163_1427)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3163_1427",
    x: -25.5229,
    y: -13.5927,
    width: 191.677,
    height: 182.785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7605,
    result: "effect1_foregroundBlur_3163_1427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3163_1427",
    x: -45.2834,
    y: -2.39521,
    width: 231.198,
    height: 191.677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.6407,
    result: "effect1_foregroundBlur_3163_1427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3163_1427",
    x: -25.5229,
    y: 17.3653,
    width: 191.677,
    height: 152.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7605,
    result: "effect1_foregroundBlur_3163_1427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3163_1427",
    x: -45.2834,
    y: -22.1555,
    width: 231.198,
    height: 211.437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.6407,
    result: "effect1_foregroundBlur_3163_1427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3163_1427",
    x: -25.5229,
    y: -2.39499,
    width: 191.677,
    height: 171.916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.7605,
    result: "effect1_foregroundBlur_3163_1427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3163_1427",
    x: -45.2834,
    y: -39.2814,
    width: 231.198,
    height: 228.563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.6407,
    result: "effect1_foregroundBlur_3163_1427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3163_1427",
    x1: 70.3154,
    y1: 25.9282,
    x2: 70.3154,
    y2: 129.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3163_1427",
    x1: 70.3154,
    y1: 56.8862,
    x2: 70.3154,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3163_1427",
    x1: 70.3154,
    y1: 56.8862,
    x2: 70.3154,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3163_1427",
    x1: 70.3154,
    y1: 37.126,
    x2: 70.3154,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3163_1427",
    x1: 70.3154,
    y1: 37.126,
    x2: 70.3154,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3163_1427",
    x1: 70.3154,
    y1: 20,
    x2: 70.3154,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63A1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104D9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBgBlue);
export default __webpack_public_path__ + "static/media/icon-bg-blue.3c4e04e69d9cc951f3c44fdc71e194c9.svg";
export { ForwardRef as ReactComponent };